import { createPageApp } from '@/lib/createPageApp'
import AuthorPage from './AuthorPage.vue'

createPageApp(AuthorPage).mount()
